import { useSetting } from '@tencent/setting-vue-webpack-plugin';
var globalSetting = useSetting('全局配置', {
  活动Id: 'test',
  默认蛋图片: 'https://puui.qpic.cn/vupload/0/20190620_1561100795415_ijn0r74rm99.png/0',
  未中奖奖品: 'https://puui.qpic.cn/vupload/0/20190624_1561551640785_5f18pv27phr.png/0',
  我的礼包: 'https://film.qq.com/weixin/v3/asset/#award',
  背景图: {
    type: 'image',
    default: 'https://puui.qpic.cn/vupload/0/1561636076137_iwnogoilyx/0'
  },
  活动逻辑: {
    type: 'object',
    properties: {
      非会员可领: false
    }
  },
  展示悬浮按钮: true,
  悬浮按钮跳转链接: 'https://film.qq.com/x/welfare/',
  悬浮按钮: 'https://puui.qpic.cn/vupload/0/20190716_1563272586752_e65qhzx2p7m.png/0'
});
window.setting = globalSetting;
export default globalSetting;